/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import '../../../capital/common';
import '../../../connect/v2/resources/address';
import '../../../capital/external/business/models';
import './applicant_individual';
import '../../../common/time';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "corporate_card": {
        "nested": {
          "resources": {
            "nested": {
              "application_flow": {
                "nested": {
                  "ApplicantBusiness": {
                    "fields": {
                      "businessName": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "ein": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "businessEntityType": {
                        "type": "squareup.capital.common.BusinessEntityType",
                        "id": 3,
                        "rule": "optional"
                      },
                      "address": {
                        "type": "squareup.connect.v2.resources.Address",
                        "id": 4,
                        "rule": "optional"
                      },
                      "managementRoleTitle": {
                        "type": "squareup.capital.external.business.models.ControllingIndividual.Title",
                        "id": 5,
                        "rule": "optional"
                      },
                      "nonManagementRoleTitle": {
                        "type": "string",
                        "id": 10,
                        "rule": "optional"
                      },
                      "ownershipBps": {
                        "type": "int32",
                        "id": 6,
                        "rule": "optional"
                      },
                      "controllingIndividuals": {
                        "type": "squareup.corporate_card.resources.application_flow.ApplicantBusiness.ControllingIndividual",
                        "id": 9,
                        "rule": "repeated"
                      },
                      "tinVerificationStatus": {
                        "type": "squareup.corporate_card.resources.application_flow.ApplicantBusiness.TinVerificationStatus",
                        "id": 7,
                        "rule": "optional"
                      },
                      "businessDisplayName": {
                        "type": "string",
                        "id": 8,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "TinVerificationStatus": {
                        "values": {
                          "AB_TVS_DO_NOT_USE": 0,
                          "PENDING": 1,
                          "VERIFIED": 2,
                          "FAILED": 3
                        }
                      },
                      "ControllingIndividual": {
                        "fields": {
                          "id": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "type": {
                            "type": "squareup.corporate_card.resources.application_flow.ApplicantBusiness.ControllingIndividual.Type",
                            "id": 2,
                            "rule": "optional"
                          },
                          "individual": {
                            "type": "squareup.corporate_card.resources.application_flow.ApplicantIndividual",
                            "id": 5,
                            "rule": "optional"
                          },
                          "remove": {
                            "type": "bool",
                            "id": 6,
                            "rule": "optional"
                          },
                          "updatedAt": {
                            "type": "squareup.common.time.DateTime",
                            "id": 7,
                            "rule": "optional"
                          },
                          "managementRoleTitle": {
                            "type": "squareup.capital.external.business.models.ControllingIndividual.Title",
                            "id": 3
                          },
                          "ownershipBps": {
                            "type": "int32",
                            "id": 4
                          }
                        },
                        "nested": {
                          "Type": {
                            "values": {
                              "CI_T_DO_NOT_USE": 0,
                              "BENEFICIAL_OWNER": 1,
                              "BUSINESS_MANAGER": 2
                            }
                          },
                          "business_relationship": {
                            "oneof": ["managementRoleTitle", "ownershipBps"]
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.corporate_card?.nested?.resources?.nested?.application_flow?.nested?.ApplicantBusiness && !$root.nested?.squareup?.nested?.corporate_card?.nested?.resources?.nested?.application_flow?.nested?.ApplicantBusiness?.nested?.TinVerificationStatus && !$root.nested?.squareup?.nested?.corporate_card?.nested?.resources?.nested?.application_flow?.nested?.ApplicantBusiness?.nested?.ControllingIndividual && !$root.nested?.squareup?.nested?.corporate_card?.nested?.resources?.nested?.application_flow?.nested?.ApplicantBusiness?.nested?.ControllingIndividual?.nested?.Type) {
  $root.addJSON(jsonData);
}

/**
 * --
 * @desc A business associated with an individual applying for a corporate card
 * --
 *
 * SOURCE ApplicantBusiness @ squareup/corporate_card/resources/application_flow/applicant_business.proto at 15:1
 */
export const ApplicantBusiness = $root.lookupType('squareup.corporate_card.resources.application_flow.ApplicantBusiness');
fixType(ApplicantBusiness);
Builder.createAndAttachToType(ApplicantBusiness);
/**
 * SOURCE TinVerificationStatus @ squareup/corporate_card/resources/application_flow/applicant_business.proto at 16:3
 */
ApplicantBusiness.TinVerificationStatus = $root.lookupEnum('squareup.corporate_card.resources.application_flow.ApplicantBusiness.TinVerificationStatus').values;
/**
 * SOURCE ControllingIndividual @ squareup/corporate_card/resources/application_flow/applicant_business.proto at 23:3
 */
ApplicantBusiness.ControllingIndividual = $root.lookupType('squareup.corporate_card.resources.application_flow.ApplicantBusiness.ControllingIndividual');
fixType(ApplicantBusiness.ControllingIndividual);
Builder.createAndAttachToType(ApplicantBusiness.ControllingIndividual);
/**
 * SOURCE Type @ squareup/corporate_card/resources/application_flow/applicant_business.proto at 24:5
 */
ApplicantBusiness.ControllingIndividual.Type = $root.lookupEnum('squareup.corporate_card.resources.application_flow.ApplicantBusiness.ControllingIndividual.Type').values;